/* Yellow Creek three-stage mobile navigation. Does not modify Expanse drawer events. */
(function(){
 if(window.__ycMobilePanelsInstalled)return;
 window.__ycMobilePanelsInstalled=true;
 function switchTo(nav,id,focusBack){
   var panel=nav.querySelector('[data-yc-panel="'+id+'"]');
   if(!panel)return;
   nav.querySelectorAll('[data-yc-panel]').forEach(function(p){
     var active=p===panel;p.hidden=!active;p.classList.toggle('is-active',active);
     if(active)p.scrollTop=0;
   });
   if(focusBack){var back=panel.querySelector('[data-yc-back]');if(back)back.focus({preventScroll:true});}
 }
 document.addEventListener('click',function(e){
   var trigger=e.target.closest('[data-yc-open],[data-yc-back]');
   if(!trigger)return;
   var nav=trigger.closest('[data-yc-mobile-navigation]');
   if(!nav)return;
   e.preventDefault();
   switchTo(nav,trigger.getAttribute('data-yc-open')||trigger.getAttribute('data-yc-back'),false);
 });
 document.addEventListener('keydown',function(e){
   if(e.key!=='Escape')return;
   var nav=document.querySelector('.site-header__mobile-nav.is-active [data-yc-mobile-navigation]');
   if(!nav)return;
   var panel=nav.querySelector('[data-yc-panel]:not([hidden])');
   if(panel && panel.dataset.ycPanel!=='root'){
     e.stopPropagation();switchTo(nav,panel.querySelector('[data-yc-back]')?.getAttribute('data-yc-back')||'root',true);
   }
 });
 document.addEventListener('mobileNav:close',function(){
   document.querySelectorAll('[data-yc-mobile-navigation]').forEach(function(nav){switchTo(nav,'root',false);});
 });
})();
